import type {
	Exact,
	InputMaybe,
	Scalars,
	ShoppingCartOrderByInput,
} from 'codegen/src/gateway/types'
import type {
	FragmentInstallmentPaymentFragment,
	FragmentItemsFieldsFragment,
	FragmentLimitsFieldsFragment,
	FragmentPromotionDtoFieldsFragment,
	FragmentSummaryDtoFieldsFragment,
} from '../fragments.generated'
import {
	FragmentInstallmentPaymentFragmentDoc,
	FragmentItemsFieldsFragmentDoc,
	FragmentLimitsFieldsFragmentDoc,
	FragmentPromotionDtoFieldsFragmentDoc,
	FragmentSummaryDtoFieldsFragmentDoc,
} from '../fragments.generated'

export type FindByUserQueryVariables = Exact<{
	channel: Scalars['String']['input']
	orderBy?: InputMaybe<ShoppingCartOrderByInput>
	canApplyPromoCode?: InputMaybe<Scalars['Boolean']['input']>
	countryIso3166_2?: InputMaybe<Scalars['String']['input']>
}>

export type FindByUserQuery = {
	findByUser?: {
		totalItems: number
		merged: boolean
		deliveries: Array<{
			order: number
			items: Array<FragmentItemsFieldsFragment | null>
		} | null>
		items: Array<FragmentItemsFieldsFragment | null>
		summary: FragmentSummaryDtoFieldsFragment
		promotion?: FragmentPromotionDtoFieldsFragment | null
		communicationMessages?: Array<{
			id?: string | null
			key?: string | null
		} | null> | null
		metadata: {
			limitsExceeded: boolean
			limits: FragmentLimitsFieldsFragment
			installmentPayment?: FragmentInstallmentPaymentFragment | null
		}
	} | null
}

export const FindByUserDocument = `
    query FindByUser($channel: String!, $orderBy: ShoppingCartOrderByInput, $canApplyPromoCode: Boolean, $countryIso3166_2: String) {
  findByUser(
    channel: $channel
    orderBy: $orderBy
    canApplyPromoCode: $canApplyPromoCode
    countryIso3166_2: $countryIso3166_2
  ) {
    ... on ShoppingCartDto {
      totalItems
      deliveries {
        order
        items {
          ...FragmentItemsFields
        }
      }
      items {
        ...FragmentItemsFields
      }
      summary {
        ...FragmentSummaryDtoFields
      }
      promotion {
        ...FragmentPromotionDtoFields
      }
      communicationMessages {
        id
        key
      }
      metadata {
        limitsExceeded
        limits {
          ...FragmentLimitsFields
        }
        installmentPayment {
          ...FragmentInstallmentPayment
        }
      }
      merged
    }
  }
}
    ${FragmentItemsFieldsFragmentDoc}
${FragmentSummaryDtoFieldsFragmentDoc}
${FragmentPromotionDtoFieldsFragmentDoc}
${FragmentLimitsFieldsFragmentDoc}
${FragmentInstallmentPaymentFragmentDoc}`
